import { useState } from 'react';
import { Clock } from 'lucide-react';
import { Button } from './ui/button';
import { Label } from './ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';

interface TimePickerProps {
  value: string; // HH:mm format (24-hour)
  onChange: (time: string) => void;
  label?: string;
}

export function TimePicker({ value, onChange, label }: TimePickerProps) {
  const [open, setOpen] = useState(false);

  const handleQuickTime = (h: number, m: number) => {
    const newTime = `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}`;
    onChange(newTime);
    setOpen(false);
  };

  const formatDisplayTime = (timeStr: string) => {
    if (!timeStr || !timeStr.includes(':')) return 'Choisir l\'heure';
    const [h, m] = timeStr.split(':');
    return `${h.padStart(2, '0')}h${m.padStart(2, '0')}`;
  };

  // Generate quick select times (every 15 minutes from 8:00 to 14:00)
  const quickTimes: Array<{ h: number; m: number; label: string }> = [];
  for (let h = 8; h <= 14; h++) {
    for (let m = 0; m < 60; m += 15) {
      if (h === 14 && m > 0) break; // Stop at 14:00
      quickTimes.push({
        h,
        m,
        label: `${h.toString().padStart(2, '0')}h${m.toString().padStart(2, '0')}`,
      });
    }
  }

  const hasValue = value && value.includes(':');

  return (
    <>
      <div className="space-y-2">
        {label && <Label>{label}</Label>}
        <Button
          variant="outline"
          onClick={() => setOpen(true)}
          className={`w-full justify-start h-11 ${!hasValue ? 'text-gray-500' : ''}`}
        >
          <Clock className="mr-2 h-4 w-4" />
          {formatDisplayTime(value)}
        </Button>
      </div>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle>Choisir l'heure de récupération</DialogTitle>
          </DialogHeader>
          <div className="grid grid-cols-5 gap-2 py-4">
            {quickTimes.map((qt) => (
              <Button
                key={qt.label}
                variant={value === `${qt.h.toString().padStart(2, '0')}:${qt.m.toString().padStart(2, '0')}` ? 'default' : 'outline'}
                size="lg"
                onClick={() => handleQuickTime(qt.h, qt.m)}
                className="text-sm font-medium h-12 touch-manipulation"
              >
                {qt.label}
              </Button>
            ))}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}

